import React, {useContext} from 'react'
import {Text} from "atmosfair-ui";
import CreateJourneyFromTravelComponentsCardItem, {
    CardListItemProps
} from "../create-journey-from-travel-components-card-item/CreateJourneyFromTravelComponentsCardItem";
import {theme} from "../../../../../styles/theme";
import {
    COMMON_COLOR,
    CreateJourneyFromTravelComponentsDayCardPropsContext,
    groupActivitiesByTravelOptionType
} from "../../../common";

import {DISPLAY_ORDER_TRAVEL_OPTIONS} from "../../../../../utils/common";
import DroppableDisabled from "../../../common/DroppableDisabled";

export interface CardGroupProps {
    isInitialGroup: CardListItemProps["isInitialGroup"],
    droppableDisabled?: boolean,
    isOver?: boolean,
}

const CreateJourneyFromTravelComponentsCardGroup = ({
                                                        droppableDisabled,
                                                        isInitialGroup,
                                                        isOver
                                                    }: CardGroupProps) => {
    const {
        activitiesAtDay,
        isRecalculatingActivityEmissions,
        draggingActivity,
    } = useContext(CreateJourneyFromTravelComponentsDayCardPropsContext)
    const activitiesGroupedByTravelOptionType = groupActivitiesByTravelOptionType(activitiesAtDay)

    return <>
        {
            isOver &&
            draggingActivity !== null &&
            typeof draggingActivity !== 'undefined' &&
            droppableDisabled &&
            <DroppableDisabled activity={draggingActivity}/>
        }
        {DISPLAY_ORDER_TRAVEL_OPTIONS.map((travelOptionType, index) => {
            return activitiesGroupedByTravelOptionType[travelOptionType] &&
                <div style={{marginTop: theme.spacer.large}} key={index}>
                    <Text
                        color={isInitialGroup ? "primary" : COMMON_COLOR}
                        variant={'headlineSmall'}>{`TRAVEL_OPTIONS.${travelOptionType.toUpperCase()}.TITLE`}</Text>
                    {activitiesGroupedByTravelOptionType[travelOptionType].map((activity, index) => {
                            if (activity) {
                                const {common: {id}} = activity
                                if (draggingActivity && draggingActivity.common.id === id) return null
                                return <CreateJourneyFromTravelComponentsCardItem
                                    loading={Boolean(isRecalculatingActivityEmissions)}
                                    isInitialGroup={isInitialGroup}
                                    activity={activity}
                                    key={index}
                                />
                            }
                        }
                    )}
                </div>
        })}
    </>
}

export default CreateJourneyFromTravelComponentsCardGroup